import {Modal} from "react-bootstrap";
import EstimateCrewTip from "./EstimateCrewTip";
import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {

    let Record = useContext(RecordsManagementContext)
    let ClientPortalHeader = Record.CP_PageDetails.ClientPortalHeader

    const hideCrewTipModal = () =>{
        Record.setCrewTipModal(false) //close crew tip modal
        Record.setInvoicePaymentModal(true)
    }

    return(
        <Modal show={Record.CrewTipModal && ClientPortalHeader.InvoicePayment.IsBilledJob} style={{top: "30%"}}>
            <Modal.Header><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>Tip For Crew </h5>
                <button onClick={() => hideCrewTipModal()}
                        style={{color: "red", background: "white", border: "white", height: "5%"}}>
                    <b>X</b></button>
            </Modal.Header>
            <Modal.Body id={'tip_for_crew_modal'}>
                <div style={{ display: Record.TipforCrew ? 'none' : 'block'}}>
                    <div><b>{Record.CP_PageDetails.TipPromptText}</b></div> <br/>
                    <div style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                        <button className='btn btn-dark' onClick={()=>hideCrewTipModal()}>No, Thank You</button>
                        <button className='btn btn-dark' style={{marginLeft: '50px'}}
                                onClick={()=>Record.setTipforCrew(true)}>Yes Please</button>
                    </div>
                </div>
                <div style={{ display: Record.TipforCrew ? 'block' : 'none' }}>
                    <EstimateCrewTip TipValue={(e)=>Record.setTipValue(e)} NewBalanceDue={(e)=>Record.setNewBalanceDue(e)} NewTotalCost={(e)=>Record.setNewTotalCost(e)} Tip={(e)=>Record.setTip(e)} FormatVisible={(e)=>Record.setFormatVisible(e)} hideCrewTipModal={hideCrewTipModal} />
                </div>
            </Modal.Body>
        </Modal>
    )
}